import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { FaCheck, FaArrowRight, FaTimes } from "react-icons/fa";

export default function SuccessModal({ show, onClose, type = "success", message }) {
    const history = useHistory();
    const isError = type === "error";

    useEffect(() => {
        if (!show || isError) return;

        const timer = setTimeout(() => {
            window.location.href = "/dashboard";
        }, 3000);

        return () => clearTimeout(timer);
    }, [show, isError]);

    if (!show) return null;

    const redirectHandler = () => {
        if (isError) {
            onClose();
        } else {
            window.location.href = "/dashboard";
        }
    };

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(15, 23, 42, 0.75)",
                backdropFilter: "blur(8px)",
                WebkitBackdropFilter: "blur(8px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 99999,
                padding: "20px"
            }}
        >
            <div
                style={{
                    backgroundColor: "#FFFFFF",
                    borderRadius: "24px",
                    padding: "40px 32px",
                    maxWidth: "460px",
                    width: "100%",
                    textAlign: "center",
                    boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
                    border: "1px solid rgba(226, 232, 240, 0.8)",
                    animation: "scaleIn 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards"
                }}
            >
                {/* Icon Header */}
                <div className="d-flex justify-content-center mb-4">
                    <div
                        style={{
                            width: "88px",
                            height: "88px",
                            borderRadius: "50%",
                            background: isError
                                ? "linear-gradient(135deg, #EF4444, #DC2626)"
                                : "linear-gradient(135deg, #10B981, #059669)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxShadow: isError
                                ? "0 12px 24px rgba(239, 68, 68, 0.3)"
                                : "0 12px 24px rgba(16, 185, 129, 0.3)",
                            position: "relative"
                        }}
                    >
                        {isError ? (
                            <FaTimes style={{ color: "#FFFFFF", fontSize: "38px" }} />
                        ) : (
                            <FaCheck style={{ color: "#FFFFFF", fontSize: "38px" }} />
                        )}
                    </div>
                </div>

                {/* Title & Description */}
                <h3
                    style={{
                        color: "#0F172A",
                        fontSize: "26px",
                        fontWeight: 700,
                        marginBottom: "12px",
                        letterSpacing: "-0.5px"
                    }}
                >
                    {isError ? "Sorry! Activation Failed 😔" : "Account Activated! 🎉"}
                </h3>

                <p
                    style={{
                        color: "#64748B",
                        fontSize: "15px",
                        lineHeight: 1.6,
                        marginBottom: "24px",
                        padding: "0 10px"
                    }}
                >
                    {isError
                        ? (message || "We could not activate your seller account. Please check your details and try again.")
                        : "Thank you! Your seller details and KYC verification have been successfully completed and approved."}
                </p>

                {/* Status Badge */}
                <div
                    style={{
                        backgroundColor: isError ? "#FEF2F2" : "#ECFDF5",
                        border: isError ? "1px solid #FECACA" : "1px solid #A7F3D0",
                        borderRadius: "12px",
                        padding: "10px 16px",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px",
                        marginBottom: "28px"
                    }}
                >
                    <span
                        style={{
                            width: "8px",
                            height: "8px",
                            borderRadius: "50%",
                            backgroundColor: isError ? "#EF4444" : "#10B981"
                        }}
                    ></span>
                    <span
                        style={{
                            color: isError ? "#991B1B" : "#065F46",
                            fontSize: "13px",
                            fontWeight: 600
                        }}
                    >
                        {isError ? "Status: Activation Error" : "Status: Active & Verified"}
                    </span>
                </div>

                {/* Action Button */}
                <button
                    onClick={redirectHandler}
                    style={{
                        width: "100%",
                        background: isError
                            ? "linear-gradient(135deg, #EF4444, #DC2626)"
                            : "linear-gradient(135deg, #F97316, #EA580C)",
                        color: "#FFFFFF",
                        border: "none",
                        borderRadius: "14px",
                        padding: "14px 24px",
                        fontSize: "16px",
                        fontWeight: 600,
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "10px",
                        boxShadow: isError
                            ? "0 10px 20px rgba(239, 68, 68, 0.3)"
                            : "0 10px 20px rgba(249, 115, 22, 0.3)",
                        transition: "transform 0.2s ease, boxShadow 0.2s ease"
                    }}
                >
                    <span>{isError ? "Try Again" : "Go To Dashboard"}</span>
                    <FaArrowRight style={{ fontSize: "14px" }} />
                </button>
            </div>
        </div>
    );
}